import { ButtonBase, styled } from '@mui/material';
import classNames from 'classnames';
import { ButtonHTMLAttributes } from 'react';
import css from './AuthButton.module.scss';

interface AuthButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  shineBehind?: boolean;
}

const StyledButtonBase = styled(ButtonBase)(({ theme }) => ({
  width: '100%',
  fontSize: '18px',
  fontWeight: 600,
  padding: '15px',
  borderRadius: '32px',
  backgroundColor: 'white',
  color: 'black',
  border: 'none',
  cursor: 'pointer',
  position: 'relative',
  zIndex: 1,
  transition: 'background-color 0.2s, outline 0.2s',
  outline: 'none',

  '&:focus-visible': {
    outline: 'none !important',
    boxShadow: 'none !important',
  },

  '&:hover': {
    backgroundColor: '#f8f9fa',
  },

  '&:disabled': {
    opacity: 0.5,
    cursor: 'not-allowed',
  },
}));

export const AuthButton = ({ children, shineBehind, ...buttonProps }: AuthButtonProps) => {
  return (
    <div className={classNames(css.authButtonContainer, shineBehind && css.shineBehind)}>
      <StyledButtonBase {...buttonProps}>{children}</StyledButtonBase>
    </div>
  );
};
